import { formatRelativeTime } from '../../../utils/timeFormat'
import UnreadBadge from './UnreadBadge'

interface ConversationItemProps {
  participantName: string
  participantEmail?: string
  lastMessage: string
  lastMessageAt: string
  unreadCount: number
  onClick: () => void
  className?: string
}

export default function ConversationItem({
  participantName,
  participantEmail,
  lastMessage,
  lastMessageAt,
  unreadCount,
  onClick,
  className = '',
}: ConversationItemProps) {
  return (
    <button onClick={onClick} className={`w-full p-4 hover:bg-gray-50 text-left ${className}`}>
      <div className="flex justify-between items-start">
        <div className="flex-1 min-w-0">
          <div className="font-medium text-gray-900">{participantName}</div>
          {participantEmail && <div className="text-sm text-gray-500">{participantEmail}</div>}
          <div className="text-sm text-gray-500 truncate">{lastMessage}</div>
          <div className="text-xs text-gray-400">{formatRelativeTime(lastMessageAt, true)}</div>
        </div>
        <UnreadBadge count={unreadCount} className="ml-2" />
      </div>
    </button>
  )
}
